export default __webpack_public_path__ + "static/media/rtvc_1920x1080.b2ed5cb5.png";